<div class="card bg-emphasis bg-opacity-25">
    <div class="card-body p-2 m-3px">
      <div *ngIf="widget.twentyfour == false" class="h1" [ngStyle]="{'font-size': widget.fontSize + 'em'}">{{ currentTime | date: 'hh:mm a' }}</div>
      <div *ngIf="widget.twentyfour == true" class="h1" [ngStyle]="{'font-size': widget.fontSize + 'em'}">{{ currentTime | date: 'H:mm' }}</div>
    </div>
  </div>